<template>
    <vApprovalComponent :postList="postList" v-if="flag"></vApprovalComponent>
</template>
<script>
import vApprovalComponent from '../../listComponent/basicdata/approval/approvalComponent.vue';
export default {
    name: 'productApproval',
    components: {
        vApprovalComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                licence_number: true,
                product_common_name: true,
                manufacturer_name: true,
                province_rid: true,
                city_rid: true,
                entity_name: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>